import styles from "../../Styles/Prayer.module.scss";
import pictureOne from "../../img/Scotland/Prayer_1.jpeg";
import pictureTwo from "../../img/Scotland/Prayer_2.jpeg";
import pictureThree from "../../img/Scotland/Prayer_3.jpeg";
import prayerPdf from "../../img/Switzerland/Prayer_for_tour_Switzerland.pdf";

function SwitzPrayer() {
  return (
    <div className="pageContainer">
      <p className="title">Prayer for our tour of Scotland</p>
      <div className="printBox">
        {/* <div className="print">
          <a href={prayerPdf} target="_blank" rel="noreferrer">
            Print PDF
          </a>
        </div> */}
      </div>

      <p className="secondaryTitle">
        I invite you to pray this (or something like it) every day for the 30
        days before departure.
      </p>

      <p className="text">
        Heavenly Father, we express our heartfelt gratitude for the incredible
        opportunity to visit the beautiful and enchanting land of Scotland. We
        pray that our journey will serve as a spiritually enriching,
        historically informative, and culturally enlightening experience for all
        participants.
      </p>
      <p className="text">
        Let our pre-trip studies prove to be enlightening and adequate
        preparation for the on-field experience. Help us to spend the time
        needed to learn the things that we will find immensely helpful on the
        trip.
      </p>
      <p className="text">
        We seek your divine protection over all life and property during our
        travels. May nothing be lost or harmed and shield us from illness or
        digestive issues caused by unfamiliar foods. We ask for a trip free of
        medical emergencies for anyone in our group. Grant us smooth flights and
        reliable transportation, free from mechanical issues, and keep us safe
        from accidents as we journey.
      </p>
      <p className="text">
        Understanding the importance of restful nights, we pray that our
        accommodations are comfortable and conducive to relaxation. May they be
        quiet and restful, allowing us to recharge for our busy days and swiftly
        adjust to a new time zone.
      </p>
      <p className="text">
        We ask that You work on our behalf, guiding our trip in a manner that
        reflects Your leading and provision. May the itinerary unfold
        seamlessly, free from a sense of urgency or pressure. Give unity and
        camaraderie within our group, encouraging each member to care for one
        another with thoughtfulness and consideration. If challenges arise,
        grant us the flexibility, courage, and faith to face them, dispelling
        doubt and complaints, and removing fear from our hearts.
      </p>
      <p className="text">
        We pray that our group leader receives special strength and health,
        consistently guided by Your influence to make sound decisions throughout
        the trip. May Your Spirit anoint him as he leads.
      </p>
      <p className="text">
        As Your ambassadors, may we embody a testimony for You wherever we go
        and with everyone we meet. Allow the light of Christ to shine brightly
        within us, unmistakably identifying us as Your people. Help us navigate
        cultural differences with sensitivity and provide us with the right
        words and actions for every situation we encounter. When the opportunity
        arises, may we witness for You.
      </p>
      <p className="text">
        To You, the Alpha and Omega, we pray for Your blessings upon our journey
        from beginning to end. We ask this in the name of our Lord, Jesus
        Christ. Amen.
      </p>

      <div className={styles.pictureBox}>
        <div>
          <img
            className={styles.picture}
            src={pictureOne}
            alt="Israel, people praying"
          />
        </div>
        {/* <div className={styles.hide}>
          <img
            className={styles.picture}
            src={pictureTwo}
            alt="Israel, people praying"
          />
        </div> */}
        <div>
          <img
            className={styles.picture}
            src={pictureThree}
            alt="Israel, people praying"
          />
        </div>
      </div>
    </div>
  );
}

export default SwitzPrayer;
